import axios from "axios";
import api from "../common/api";
require("dotenv").config();

const setToken = async (token, expires_in) => {
  var dt = new Date();
  var expires_in = expires_in / 60;
  var expires_at = new Date(dt.getTime() + expires_in * 60000);
  localStorage.setItem("userToken", token, function(error) {
    if (error) {
      console.error("Error al guardar el token:", error);
    }
  });
  localStorage.setItem("expires_at", expires_at, function(error) {
    if (error) {
      console.error("Error al guardar la expiración:", error);
    }
  });
};
const setUserInfo = async res => {
  localStorage.setItem("userData", JSON.stringify(res.data), function(error) {
    if (error) {
      console.error("Error al guardar info del usuario:", error);
    }
  });
  localStorage.setItem("userName", res.data.name, function(error) {
    if (error) {
      console.error("Error al guardar info del usuario:", error);
    }
  });
  localStorage.setItem("userEmail", res.data.email, function(error) {
    if (error) {
      console.error("Error al guardar info del usuario:", error);
    }
  });
  localStorage.setItem("userRoles", JSON.stringify(res.data.roles), function(
    error
  ) {
    if (error) {
      console.error("Error al guardar info del usuario:", error);
    }
  });
  localStorage.setItem("userLayout", res.data.layout, function(error) {
    if (error) {
      console.error("Error al guardar info del usuario:", error);
    }
  });
};

export const login = async user => {
  localStorage.removeItem("userData");
  localStorage.removeItem("userToken");
  return await axios
    .post(
      api.token,
      {
        grant_type: "password",
        scope: "*",
        client_id: "5",
        client_secret: process.env.REACT_APP_API_SECRET,
        username: user.email,
        password: user.password
      },
      {
        headers: { "Content-Type": "application/json" }
      }
    )
    .then(async res => {
      await setToken(res.data.access_token, res.data.expires_in);
      await getProfile();
      return res;
    })
    .catch(err => {
      return err;
    });

  return true;
};

export const getProfile = async () => {
  return await axios
    .get(api.user, {
      headers: { Authorization: `Bearer ${localStorage.userToken}` }
    })
    .then(async res => {
      await setUserInfo(res);

      localStorage.setItem("userData", JSON.stringify(res.data));
      localStorage.setItem("userName", res.data.name);
      localStorage.setItem("userEmail", res.data.email);
      localStorage.setItem("userRoles", JSON.stringify(res.data.roles));
      localStorage.setItem("userLayout", res.data.layout);
      if (res.data.provider) {
        localStorage.setItem("provider", JSON.stringify(res.data.provider));
        localStorage.setItem("providerId", res.data.provider.id);
      }
      return res.data;
    })
    .catch(err => {
      console.log(err);
    });
};

export const changeResetedPasswordRequest = request => {
  var formData = new FormData();
  formData.set("password", request.password);
  formData.set("email", request.email);
  formData.set("token", request.token);
  formData.set("password_confirmation", request.repeatPassword);
  return axios
    .post(api.changeResetedPassword, formData, {})
    .then(res => {
      return res;
    })
    .catch(err => {
      return err;
    });
};

export const changePasswordRequest = request => {
  var formData = new FormData();
  formData.set("email", request.email);
  formData.set("password", request.password);
  formData.set("new_password", request.new_password);
  formData.set("confirm_password", request.confirm_password);
  return axios
    .post(api.changePassword, formData, {})
    .then(res => {
      return res;
    })
    .catch(err => {
      return err;
    });
};

export const resetPasswordRequest = email => {
  var formData = new FormData();
  formData.set("email", email);
  return axios
    .post(api.resetPassword, formData, {})
    .then(res => {
      return res;
    })
    .catch(err => {
      return err;
    });
};

export const validateTokenRequest = token => {
  var formData = new FormData();
  formData.set("token", token);
  return axios
    .get(api.findToken + "/" + token, formData, {})
    .then(res => {
      return res;
    })
    .catch(err => {
      return err;
    });
};

export const logout = () => {
  localStorage.removeItem("userData");
  localStorage.removeItem("userName");
  localStorage.removeItem("userEmail");
  localStorage.removeItem("userToken");
  localStorage.removeItem("userRoles");
  localStorage.removeItem("userLayout");
  localStorage.removeItem("expires_at");
  window.location.href = "/login";
};
export const userHasRole = targetName => {
  const storedUserRoles = JSON.parse(localStorage.getItem("userRoles")) || [];
  return storedUserRoles.some(role => role.name === targetName);
};
